import { useCallback, useMemo } from 'react';
import useInfiniteFetch from '../useInfiniteFetch';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { WDAC_CATALOG_INVENTORY_AFFECTED_DEVICES_KEY } from 'src/constants/query';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useQueryParams from '../../hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import CatalogInventoryService from '../../services/catalog-inventory.service';

const useGetCatalogInventoryAffectedDevices = ({catalogInventoryId}) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const {
    queryObject: { searchValue: initialSearchValue, filters = {} },
  } = useQueryParams();

  const query = useMemo(
    () =>
      parseQueryToApiQuery({
        filters,
        searchValue: initialSearchValue,
      }),
    [filters, initialSearchValue],
  );

  const fetchFunction = useCallback(
    ({ page, limit }) =>
      CatalogInventoryService.getCatalogInventoryDevices({
        limit,
        page,
        catalogInventoryId,
        customerEnvId,
        query,
      }),
    [catalogInventoryId, customerEnvId, query],)

  const response = useInfiniteFetch({
    queryKey: [WDAC_CATALOG_INVENTORY_AFFECTED_DEVICES_KEY, query, customerEnvId, catalogInventoryId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'affectedDevices',
  });
  return {
    ...response,
    query,
  };
};

export default useGetCatalogInventoryAffectedDevices;
